<div class="dropdown">
    <div class="dropdown__initial-text" (click)="toggleItems()">
        {{ initialText }}
        <img
            src="/assets/icons/chevron-down.svg"
            alt="Arrow"
            class="dropdown__arrow"
            [class.dropdown__arrow--open]="showItems"
        />
    </div>
    <div class="dropdown__items" [class.dropdown__items--visible]="showItems">
        <div
            *ngFor="let item of items"
            class="dropdown__item"
            [class.dropdown__item--clickable]="
                !item.active && (!item.type || item.type === type.Link)
            "
            [class.dropdown__item--active]="item.active"
            [class.dropdown__item--title]="item.type === type.Title"
            [class.dropdown__item--separator]="item.type === type.Separator"
            (click)="
                !item.active && (!item.type || item.type === type.Link) && toggleItems();
                item.action && item.action(item)
            "
            [id]="!!item.id && item.id"
        >
            <img *ngIf="item.icon" [src]="getIconPath(item.icon)" alt="{{ item.text || 'Icon' }}" />
            <img *ngIf="item.imgSrc" [src]="item.imgSrc" alt="Icon" />
            <span *ngIf="item.text" class="dropdown__item__text">{{ item.text }}</span>
        </div>
    </div>
</div>
